import landrover_defender_2016_0 from '@/public/assets/landrover/landrover_defender_2016-0.jpg'
import landrover_defender_2016_1 from '@/public/assets/landrover/landrover_defender_2016-1.jpg'
import landrover_defender_2016_2 from '@/public/assets/landrover/landrover_defender_2016-2.jpg'
import landrover_defender_2016_3 from '@/public/assets/landrover/landrover_defender_2016-3.jpg'
import landrover_defender_2016_4 from '@/public/assets/landrover/landrover_defender_2016-4.jpg'
import landrover_defender_2016_5 from '@/public/assets/landrover/landrover_defender_2016-5.jpg'
import landrover_defender_2016_6 from '@/public/assets/landrover/landrover_defender_2016-6.jpg'
import landrover_defender_2016_7 from '@/public/assets/landrover/landrover_defender_2016-7.jpg'
import landrover_defender_2016_8 from '@/public/assets/landrover/landrover_defender_2016-8.jpg'
import landrover_defender_2016_9 from '@/public/assets/landrover/landrover_defender_2016-9.jpg'
import landrover_defender_2016_91 from '@/public/assets/landrover/landrover_defender_2016-91.jpg'
import landrover_defender_2016_92 from '@/public/assets/landrover/landrover_defender_2016-92.jpg'
import landrover_defender_2016_93 from '@/public/assets/landrover/landrover_defender_2016-93.jpg'
import landrover_defender_2016_94 from '@/public/assets/landrover/landrover_defender_2016-94.jpg'
import landrover_defender_2016_95 from '@/public/assets/landrover/landrover_defender_2016-95.jpg'
import landrover_defender_2016_96 from '@/public/assets/landrover/landrover_defender_2016-96.jpg'
import landrover_defender_2016_97 from '@/public/assets/landrover/landrover_defender_2016-97.jpg'
import landrover_defender_2016_98 from '@/public/assets/landrover/landrover_defender_2016-98.jpg'

export const landrover = [
    landrover_defender_2016_0,
    landrover_defender_2016_1,
    landrover_defender_2016_2,
    landrover_defender_2016_3,
    landrover_defender_2016_4,
    landrover_defender_2016_5,
    landrover_defender_2016_6,
    landrover_defender_2016_7,
    landrover_defender_2016_8,
    landrover_defender_2016_9,
    landrover_defender_2016_91,
    landrover_defender_2016_92,
    landrover_defender_2016_93,
    landrover_defender_2016_94,
    landrover_defender_2016_95,
    landrover_defender_2016_96,
    landrover_defender_2016_97,
    landrover_defender_2016_98,
]
